export default "__VITE_ASSET__7Q2sHxBl__"